import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import $ from 'jquery';
import moment from 'moment';
import Tabs from './ui/react-ui/tabs';
import Progress from './ui/react-ui/progress.jsx';
import Traffic from './trafficPrediction/traffic';
import MapAnalytics from './trafficPrediction/mapAnalytics';
import Statistics from './trafficPrediction/statistics'; // api

import { getVds } from '../api/deviceAPI';
import { getAreaTerminals, getAreaTerminalsDeliverTypeSeparated, getAreaGates } from '../api/areaAPI';
import { getTrafficEventTypeList } from '../api/eventAPI';
import { getTerminalPrediction, getGatePrediction, getTrafficRoadSectionPredByDay } from '../api/predictionAPI'; // redux

import { setEventTypeList, setVdsData, setVdsTotalCount, setTerminalsData, setTerminalsTotalCount, setGatesData, setGatesTotalCount, setTerminalsChartData, setGatesChartData, setTrafficLiveChartData, reset } from '../redux/traffic-prediction';
var t = i18n.getFixedT(null, 'traffic-prediction');
var TrafficPrediction = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$trafficP = _useSelector.trafficPrediction,
      vdsSort = _useSelector$trafficP.vdsSort,
      terminalsSort = _useSelector$trafficP.terminalsSort,
      gatesSort = _useSelector$trafficP.gatesSort;

  var dispatch = useDispatch();

  var _useState = useState('traffic'),
      _useState2 = _slicedToArray(_useState, 2),
      currentTab = _useState2[0],
      setCurrentTab = _useState2[1];

  var isMounted = useRef(false);
  var id = props.id;
  var tabsMenu = [{
    key: 'traffic',
    title: t('lbl-traffic-analytics')
  }, {
    key: 'map',
    title: t('lbl-map-analytics')
  }, {
    key: 'statistics',
    title: t('lbl-statistics')
  }];

  var fetchData = function fetchData() {
    Progress.startSpin();
    var getVds_api = getVds(contextRoot, true);
    var getTerminals_api = getAreaTerminalsDeliverTypeSeparated(contextRoot, true);
    var getGates_api = getAreaGates(contextRoot, true);
    var getEventTyep_api = getTrafficEventTypeList(contextRoot, true);
    var getTerminalPrediction_api = getTerminalPrediction(contextRoot, true);
    var getTerminalsList = getAreaTerminals(contextRoot, true);
    var getGatePrediction_api = getGatePrediction(contextRoot);
    var getGatesList_api = getAreaGates(contextRoot, true);
    var initDateTime = {
      from: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm'),
      to: moment().format('YYYY-MM-DD HH:mm')
    };
    var getTrafficRoadSectionPredByDay_api = getTrafficRoadSectionPredByDay(contextRoot, true, initDateTime);
    $.when(getVds_api, getTerminals_api, getGates_api, getEventTyep_api, getTerminalPrediction_api, getTerminalsList, getGatePrediction_api, getGatesList_api, getTrafficRoadSectionPredByDay_api).then(function (vds_result, terminals_result, gates_api, eventType_result, terminalPrediction_result, terminalsList_result, gatePrediction_result, gatesList_result, roadSection_result) {
      var newVdsData = _.map(vds_result.content, function (el) {
        return _objectSpread(_objectSpread({}, el), {}, {
          congestionStatus: parseInt(el.speed) === -1 ? -1 : el.congestionStatus
        });
      });

      dispatch(setVdsData(newVdsData));
      dispatch(setVdsTotalCount(vds_result.totalElements));

      var terminalData = _.map(terminals_result.content, function (el) {
        return _objectSpread(_objectSpread({}, el), {}, {
          congestionStatus: parseInt(el.estLineDuration) === -1 ? -1 : el.congestionStatus
        });
      });

      dispatch(setTerminalsData(terminalData));
      dispatch(setTerminalsTotalCount(terminals_result.totalElements));

      var gatesData = _.map(gates_api.content, function (el) {
        return _objectSpread(_objectSpread({}, el), {}, {
          congestionStatus: parseInt(el.estVisitDuration) === -1 ? -1 : el.congestionStatus
        });
      });

      dispatch(setGatesData(gatesData));
      dispatch(setGatesTotalCount(gates_api.totalElements));
      dispatch(setEventTypeList(eventType_result.content)); // Handle terminal chart data

      var tpData = terminalPrediction_result.content.sort(function (a, b) {
        return moment(a.time).valueOf() - moment(b.time).valueOf();
      });
      var terminalChartData = {};
      var terminalMissTimeAry = [];

      _.map(tpData, function (el) {
        var terminals = _.find(terminalsList_result.content, function (e) {
          return e.id === el.terminalId;
        });

        if (terminals) {
          if (terminals.name in terminalChartData === false) terminalChartData[terminals.name] = [];
          terminalChartData[terminals.name].push({
            time: el.time,
            value: el.estTrailerLineQty
          });
        } else {
          terminalMissTimeAry = [].concat(_toConsumableArray(terminalMissTimeAry), [{
            time: el.time
          }]);
        }
      });

      if (terminalMissTimeAry.length > 0) {
        terminalMissTimeAry.map(function (o) {
          _.map(terminalChartData, function (el) {
            var isMissTime = _.find(el, function (el) {
              return el.time === o.time;
            }) ? false : true;
            if (isMissTime) el.push(o);
          });
        });
      }

      _.map(terminalChartData, function (el) {
        return el.sort(function (a, b) {
          return moment(a.time).valueOf() - moment(b.time).valueOf();
        });
      });

      dispatch(setTerminalsChartData(terminalChartData)); // handle gate chart data

      var gpData = gatePrediction_result.content.sort(function (a, b) {
        return moment(a.time).valueOf() - moment(b.time).valueOf();
      });
      var gateChartData = {};
      var gateMissTimeAry = [];

      _.map(gpData, function (el) {
        var gates = _.find(gatesList_result.content, function (e) {
          return e.id === el.gateId;
        });

        if (gates) {
          if (gates.name in gateChartData === false) gateChartData[gates.name] = [];
          gateChartData[gates.name].push({
            time: el.time,
            value: Math.round(el.estVisitDuration)
          });
        } else {
          gateMissTimeAry = [].concat(_toConsumableArray(gateMissTimeAry), [{
            time: el.time
          }]);
        }
      });

      if (gateMissTimeAry.length > 0) {
        gateMissTimeAry.map(function (o) {
          _.map(gateChartData, function (el) {
            var isMissTime = _.find(el, function (el) {
              return el.time === o.time;
            }) ? false : true;
            if (isMissTime) el.push(o);
          });
        });
      }

      _.map(gateChartData, function (el) {
        return el.sort(function (a, b) {
          return moment(a.time).valueOf() - moment(b.time).valueOf();
        });
      });

      dispatch(setGatesChartData(gateChartData));
      var roadSectionByDayData = {};

      _.map(roadSection_result.content, function (el) {
        var name = el.roadSectionName;
        roadSectionByDayData[name] = [];
        var item = roadSectionByDayData[name];

        _.forEach(el.stats, function (o) {
          var calTime = function calTime(t) {
            return t < 10 ? '0' + t : t;
          };

          item.push({
            time: calTime(o.hour) + ':' + calTime(o.minute),
            value: o.avgSpeedPrediction
          });
        });
      });

      dispatch(setTrafficLiveChartData(roadSectionByDayData));
      Progress.done();
    });
  };

  var renderTabContent = function renderTabContent() {
    switch (currentTab) {
      case 'traffic':
        return /*#__PURE__*/React.createElement(Traffic, null);

      case 'map':
        return /*#__PURE__*/React.createElement(MapAnalytics, null);

      case 'statistics':
        return /*#__PURE__*/React.createElement(Statistics, null);
    }
  };

  useEffect(function () {
    if (!isMounted.current) return;
    if (currentTab === 'traffic') fetchData();
  }, [currentTab]);
  useEffect(function () {
    if (!isMounted.current) {
      fetchData();
      isMounted.current = true;
    }

    return function () {
      dispatch(reset());
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement(Tabs, {
    id: "g-traffic-prediction-tabs",
    current: currentTab,
    menu: tabsMenu,
    onChange: function onChange(key) {
      return setCurrentTab(key);
    }
  }, renderTabContent()));
});
TrafficPrediction.defaultProps = {
  id: 'g-traffic-prediction'
};
TrafficPrediction.PropTypes = {
  id: PropTypes.string
};
export default TrafficPrediction;